import { createFeatureSelector, createSelector } from '@ngrx/store';
import { sharedFeatureKey } from 'src/app/shared/selectors';
import { SharedState } from 'src/app/shared/state/shared.state';

export const selectSharedFeature = createFeatureSelector<SharedState>(sharedFeatureKey);

export const selectJobQualifications = createSelector(
    selectSharedFeature,
    (state) => state.jobQualifications.qualifications
);

export const selectJobQualificationsLoading = createSelector(
    selectSharedFeature,
    (state) => state.jobQualifications.isLoading
);

export const selectSideDrawerLoading = createSelector(
    selectSharedFeature,
    (state) => state.jobQualifications.sideDrawerLoading
);

export const selectAvailableSkills = createSelector(
    selectSharedFeature,
    (state) => state.jobQualifications.availableSkills
);

export const selectAvailableCerts = createSelector(
    selectSharedFeature,
    (state) => state.jobQualifications.availableCerts
);

export const selectJobQualificationChanges = createSelector(
    selectSharedFeature,
    (state) => state.jobQualifications.changes
);

export const selectJobQualificationChangesLoading = createSelector(
    selectSharedFeature,
    (state) => state.jobQualifications.isChangesLoading
);

export const selectJobQualificationChangesLoaded = createSelector(
    selectSharedFeature,
    (state) => !!state.jobQualifications.changes
);
